import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512",
  class: "cn_svg__PartnerHeader_flag_1DJOe"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><path id=\"cn_svg__a\" fill=\"#ff0\" d=\"M1-.3L-.7.8 0-1 .6.8-1-.3z\"></path></defs><path fill=\"#ee1c25\" d=\"M0 0h512v512H0z\"></path><use xlink:href=\"#cn_svg__a\" width=\"30\" height=\"20\" transform=\"matrix(76.8 0 0 76.8 128 128)\"></use><use xlink:href=\"#cn_svg__a\" width=\"30\" height=\"20\" transform=\"rotate(-121 142.6 -47) scale(25.5827)\"></use><use xlink:href=\"#cn_svg__a\" width=\"30\" height=\"20\" transform=\"rotate(-98.1 198 -82) scale(25.6)\"></use><use xlink:href=\"#cn_svg__a\" width=\"30\" height=\"20\" transform=\"rotate(-74 272.4 -114) scale(25.6137)\"></use><use xlink:href=\"#cn_svg__a\" width=\"30\" height=\"20\" transform=\"matrix(16 -19.968 19.968 16 256 230.4)\"></use>", 7)
const _hoisted_9 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_9]))
}
export default { render: render }